// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=6a033bd3-5a94-4df3-b42c-4b44be9f6d7c";
};